var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCan = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1474_25611)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.9994 11.9997C23.9994 7.24218 21.2308 3.13143 17.2168 1.19043V22.8089C21.2308 20.868 23.9994 16.7572 23.9994 11.9997V11.9997Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 11.9997C0 16.7572 2.76867 20.868 6.78263 22.809V1.19043C2.76867 3.13143 0 7.24218 0 11.9997Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.087 13.565L16.174 12.5215L15.1305 11.9998V10.9563L13.0435 11.9998L14.087 9.91286H13.0435L12.0001 8.34766L10.9566 9.91286H9.91309L10.9566 11.9998L8.86961 10.9563V11.9998L7.82617 12.5215L9.91309 13.565L9.39138 14.6085H11.4783V16.1737H12.5218V14.6085H14.6088L14.087 13.565Z",
  fill: "#D80027"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1474_25611"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCan);
export { ForwardRef as ReactComponent };